import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import Navbar from "./components/Navbar";

// Home sections
import Home from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WebsiteCheckModal from "./components/WebsiteCheckModal";

// Service pages
import WebDevelopment from "./components/WebDevelopment";
import SEO from "./components/Seo";
import SMM from "./components/Smm";
import DigitalMarketing from "./components/DigitalMarketing";
import AppDevelopment from "./components/AppDevelopment";

// Man Power page
import Manpower from "./components/Manpower";

// Layout
import ServiceLayout from "./components/ServiceLayout";

// Scroll helper
import ScrollToTop from "./components/ScrollToTop";

import "./App.css";

function LandingPage({ setOpenModal }) {
  return (
    <>
      <Home />
      <About />
      <Services />
      <Projects />
      <Contact />
      <Footer />

      <button
        className="website-check-btn"
        onClick={() => setOpenModal(true)}
        type="button"
      >
        Check Your Website Health
      </button>
    </>
  );
}

function App() {
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Navbar />

      <Routes>
        {/* Home */}
        <Route path="/" element={<LandingPage setOpenModal={setOpenModal} />} />

        {/* Contact Page */}
        <Route path="/contact" element={<Contact />} />

        {/* Man Power */}
        <Route path="/manpower" element={<Manpower />} />

        {/* Services */}
        <Route
          path="/services/web-development"
          element={
            <ServiceLayout>
              <WebDevelopment />
            </ServiceLayout>
          }
        />
        <Route
          path="/services/search-engine-optimization"
          element={
            <ServiceLayout>
              <SEO />
            </ServiceLayout>
          }
        />
        <Route
          path="/services/social-media-management"
          element={
            <ServiceLayout>
              <SMM />
            </ServiceLayout>
          }
        />
        <Route
          path="/services/digital-marketing"
          element={
            <ServiceLayout>
              <DigitalMarketing />
            </ServiceLayout>
          }
        />
        <Route
          path="/services/app-development"
          element={
            <ServiceLayout>
              <AppDevelopment />
            </ServiceLayout>
          }
        />
      </Routes>

      <WebsiteCheckModal open={openModal} onClose={() => setOpenModal(false)} />
    </Router>
  );
}

export default App;
